import * as Sentry from "@sentry/vue";

// 限制 sentry 收集错误时系统版本。
export const fnIsLowVersion = () => {
    const ua = navigator.userAgent;
    const androidMatch = ua.match(/Android (\d+(?:\.\d+)+)/i);
    const iosMatch = ua.match(/OS (\d+)_(\d+)?/i);
    let isLowAndroid = false;
    let isLowIos = false;
    if (androidMatch && androidMatch[1]) {
        isLowAndroid = parseFloat(androidMatch[1]) < 7;
    }
    if (iosMatch && iosMatch[1]) {
        isLowIos = parseFloat(iosMatch[1]) < 10;
    }
    return isLowAndroid || isLowIos;
};
// 获取 html 底部注释信息。
export const fnGetCommentInfo = () => {
    try {
        const nodes = document.childNodes;
        const commentList: Node[] = Array.from(nodes).reduce<Node[]>((total, item) => {
            if(item.nodeType === Node.COMMENT_NODE) total.push(item);
            return total;
        }, []);
        const buildInfo = Array.from(commentList).at(-3)?.textContent?.replace(/[^\S\n]/g, '');
        return buildInfo;
    } catch (error) {
        return `fnGetCommentInfo err: ${error}`;
    }
}

export const fnIsJsBridgeError = (event: Sentry.Event) => {
    const {exception} = event;
    if(exception && exception.values) {
        const isJsBridgeReport = exception.values.some((item: Sentry.Exception) => item.value?.includes('MicoJSBridge'));
        return isJsBridgeReport;
    }
    else {
        return false;
    }
}

export type Config = {
    //  获取活动所用 lang
    language?:{
        use: boolean;
        country: string[];
    }
    //  sentry 相关配置
    sentry?: {
        use: boolean;
        dsn: string;
    };
};